import store from "../redux/store";
import {
	getCulture as getCultureSelector,
	getPreservedSaveDetailsDataSelector,
	getMotorcycleModels,
	getPriceAvailability,
	getConfigurationWasRecentlyCreatedSelector,
	getConfigurationIsDirtySelector
} from "../redux/selectors";
import { Setup } from "../components/setups/SetupsList";
import {
	Price,
	VehicleInformation
} from "../components/main/motorcycles/MotorcycleView";
import { Part } from "../components/parts/PartsList";
import { hideToast, showToast } from "../redux/actions";
import { getVehicleInformation } from "../redux/reducers/models";
import { SaveDetailsData } from "../components/dialogs/saveConfiguration";

let timeoutHolder: NodeJS.Timeout;

export function getSetupParts(setup: Setup): Part[] {
	return getAllParts().filter((part: Part) =>
		setup.PartIds.includes(part.PartId)
	);
}

export function toastMessage(message: string) {
	// make sure no previous toasts are visible
	timeoutHolder && clearTimeout(timeoutHolder);
	store.dispatch(hideToast());
	store.dispatch(showToast(message));
	timeoutHolder = setTimeout(() => store.dispatch(hideToast()), 1900);
}

export function calculateSetupPrice(selected: Setup): Price {
	const pricesAreAvailable = getPriceAvailability(store.getState());

	if (!pricesAreAvailable) {
		return null;
	}

	const bareSetupPrice = store.getState().vehicleOverviewState.Vehicle.Hero
		.Price;

	if (!bareSetupPrice) {
		return null;
	}

	return {
		...bareSetupPrice,
		Value: bareSetupPrice.Value + getPartsValue(getSetupParts(selected))
	};
}

export function getConfigurationId(): number {
	return store.getState().configurationState.configuration.ConfigurationId;
}

export function getEntryPointUrl() {
	return store.getState().configurationState.entryPointUrl;
}

export function getCulture(): string {
	return getCultureSelector(store.getState());
}

export function getPreservedSaveDetailsData(): SaveDetailsData {
	return getPreservedSaveDetailsDataSelector(store.getState());
}

export const getConfigurationWasRecentlyCreated = () =>
	getConfigurationWasRecentlyCreatedSelector(store.getState());

export const getConfigurationIsDirty = () =>
	getConfigurationIsDirtySelector(store.getState());

function getPartsValue(parts: Part[]) {
	return parts.reduce((acc: number, part: Part) => {
		return acc + (part.Price === null ? 0 : part.Price.Value);
	}, 0);
}

function getAllParts(): Part[] {
	return store.getState().vehicleOverviewState.Parts;
}

export function getVehicleById(id: string): VehicleInformation | undefined {
	return getVehicleInformation(getMotorcycleModels(store.getState())).find(
		(item: VehicleInformation) => item.ModelId === id
	);
}

export function getPartById(id: string) {
	return getAllParts().find((part: Part) => part.PartId === id) as Part;
}

export function getLocaleQuery() {
	const { culture, market, companyId } = store.getState().configurationState;
	return `?cid=${companyId}&c=${culture}&m=${market}`;
}

export function sortAscendingByProperty<T extends { [key: string]: string }>(
	key: keyof T
) {
	return (previous: T, next: T) => {
		const Previous = previous[key].toUpperCase();
		const Next = next[key].toUpperCase();
		return Previous > Next ? 1 : Previous < Next ? -1 : 0;
	};
}
